import { render, staticRenderFns } from "./HomeMenuCard.vue?vue&type=template&id=ebf075cc&scoped=true&lang=pug&"
import script from "./HomeMenuCard.vue?vue&type=script&lang=ts&"
export * from "./HomeMenuCard.vue?vue&type=script&lang=ts&"
import style0 from "./HomeMenuCard.vue?vue&type=style&index=0&id=ebf075cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf075cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardSubtitle,VCardTitle,VIcon})
